import {sbkCoreBreakpointLg, sbkCoreBreakpointMd} from '@/tokens/variables';
import { css, unsafeCSS } from 'lit';

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        position: relative;
    }

    .teaser__container {
        color: var(--sbkTeaserColorFgColorOnLightEnabled);
        border-radius: var(--sbkTeaserBorderRadiusDefault);
        font: var(--sbkTeaserTypographySmallScreenBodySm);
        overflow: hidden;
        outline-offset: var(--sbkTeaserBorderGapFocus);
        border: 1px solid transparent;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        height: 100%;

        &:focus-visible {
            outline: var(--sbkTeaserBorderFocus);
            border-radius: var(--sbkTeaserBorderRadiusFocus);
        }

        &:hover {
            border: var(--sbkTeaserBorderHover);
        }
    }

    @media (min-width: ${breakpointLg}) {
        .teaser__container {
            font: var(--sbkTeaserTypographyLargeScreenBodySm);
            display: flex;
            flex-direction: row;
        }

        .teaser__header {
            font: var(--sbkTeaserTypographyLargeScreenBodyMd);
        }
    }

    .vertical {
        display: flex;
        flex-direction: column;
    }

    .horizontal {
        display: flex;
        flex-direction: column;

        @media (min-width: ${breakpointMd}) {
            flex-direction: row;

            .image-slot__size--default {
                flex: 0 1 calc(100% / 12 * 3);
            }

            .image-slot__size--large {
                flex: 0 1 calc(100% / 12 * 7);
            }
        }
        
    }

    .horizontal-reverse {
        display: flex;
        flex-direction: column;
        
        @media (min-width: ${breakpointMd}) {
          flex-direction: row-reverse;

          .image-slot__size--default {
            flex: 0 1 calc(100% / 12 * 3);
          }

          .image-slot__size--large {
            flex: 0 1 calc(100% / 12 * 7);
          }
        }
    }

  .image-container {
    display: block;
    flex: 0 1 auto;
  }

  .image-slot::slotted(img) {
    object-fit: cover;
    display: block;
    height: 100% !important;
    max-width: 100%;
    width: 100%;
  }

  .image-slot--16to9::slotted(*) {
    aspect-ratio: 16 / 9;
  }

  .image-slot--1to1::slotted(*) {
    aspect-ratio: 1 / 1;
  }

  .image-slot--3to2::slotted(*) {
    aspect-ratio: 3 / 2;
  }

  .image-slot--4to3::slotted(*) {
    aspect-ratio: 4 / 3;
  }

  .image-slot--5to2::slotted(*) {
    aspect-ratio: 5 / 2;
  }

  .content-wrapper {
    background-color: var(--sbkTeaserColorBgColorDefault);
    display: flex;
    flex-direction: column;
    gap: var(--sbkTeaserSpacingSmallScrGap);
    flex: 1;
    padding: var(--sbkTeaserSpacingSmallScrInsetTop) var(--sbkTeaserSpacingSmallScrInsetRight) var(--sbkTeaserSpacingSmallScrInsetBottom) var(--sbkTeaserSpacingSmallScrInsetLeft);

    @media (min-width: ${breakpointLg}) {
      gap: var(--sbkTeaserSpacingLargeScrGap);
      padding: var(--sbkTeaserSpacingLargeScrInsetTop) var(--sbkTeaserSpacingLargeScrInsetRight) var(--sbkTeaserSpacingLargeScrInsetBottom) var(--sbkTeaserSpacingLargeScrInsetLeft);
    }

    .teaser__header {
      font: var(--sbkTeaserTypographySmallScreenBodyMd);
    }
  }

  .teaser__content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: var(--sbkTeaserSpacingSmallScrGap);

    @media (min-width: ${breakpointLg}) {
      gap: var(--sbkTeaserSpacingLargeScrGap);
    }
  }

  .headline,
  .annotation-wrapper,
  .teaser__icon-wrapper,
  .teaser__footer {
    display: flex;
    align-items: center;
  }

  .annotation-wrapper {
    justify-content: space-between;
    width: 100%;
  }

  .teaser__footer {
    justify-content: space-between;
  }

  .teaser__footer-slot {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .teaser__footer-right-slot {
    display: flex;
    justify-content: flex-end;
  }

  .horizontal .teaser-body {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
    
    .hidden {
        display: none;
    }
    
    ::slotted(*:last-child) {
        margin: 0 !important;
    }
`;
